module.exports = __webpack_public_path__ + "img/J12621.b800917d.png";